
import { OptionsClass } from "@/domain/entities/MainApp";
import { Options, Vue, prop } from "vue-class-component";
import CustomDropdown from "@/app/ui/components/custom-dropdown/index.vue";
import LastLocationFilterSection from "@/app/ui/views/urgent-delivery-management/components/shared/last-location-filter-section.vue";
import {
  LastLocationOption,
  LastLocationOptionValue
} from "@/domain/entities/UrgentDeliveryManagement";

class Props {
  currentParameters = prop<any>({
    required: true
  });
  options = prop<LastLocationOption[]>({
    default: () => []
  });
}

@Options({
  components: {
    CustomDropdown,
    LastLocationFilterSection
  },
  emits: ["apply"],
  directives: {
    "click-outside": {
      beforeMount: function(el, binding) {
        const ourClickEventHandler = (event: any) => {
          // Fix for detached elements (e.g. dropdown options removed on click)
          if (!document.body.contains(event.target)) return;

          if (!el.contains(event.target) && el !== event.target) {
            binding.value(event);
          }
        };
        el.__vueClickEventHandler__ = ourClickEventHandler;
        document.addEventListener("click", ourClickEventHandler);
      },
      unmounted: function(el) {
        document.removeEventListener("click", el.__vueClickEventHandler__);
      }
    }
  }
})
export default class UrgentRTSFilter extends Vue.with(Props) {
  isOpen = false;
  tempLastLocation: LastLocationOptionValue[] = [];

  tempParameters = {
    caseType: new OptionsClass(),
    productType: new OptionsClass(),
    sttClientAggregatorType: new OptionsClass()
  };

  productTypeOptions = [
    "VIPPACK",
    "BOSSPACK",
    "REGPACK",
    "MINIPACK",
    "BIGPACKFAST",
    "JAGOPACK",
    "BIGPACK",
    "INTERMAXXI",
    "INTERPACK",
    "ONEPACK"
  ].map((pd) => new OptionsClass({ name: pd, value: pd }));

  get caseTypeData(): OptionsClass[] {
    return [
      new OptionsClass({
        name: "DEX",
        value: "DEX"
      }),
      new OptionsClass({
        name: "CODREJ",
        value: "CODREJ"
      }),
      new OptionsClass({
        name: this.$t(
          "urgentDeliveryManagement.filter.customerRequest"
        ) as string,
        value: "Permintaan Customer"
      })
    ];
  }

  get aggregatorTypeOptions(): OptionsClass[] {
    return [
      new OptionsClass({
        name: this.$t("urgentDeliveryManagement.rts.aggregator") as string,
        value: "aggregator"
      }),
      new OptionsClass({
        name: this.$t("urgentDeliveryManagement.rts.nonAggregator") as string,
        value: "non_aggregator"
      })
    ];
  }

  get filterCount() {
    let count = 0;
    if (this.currentParameters.caseType?.value) count++;
    if (this.currentParameters.productType?.value) count++;
    if (this.currentParameters.sttClientAggregatorType?.value) count++;
    if (
      this.currentParameters.cityCode?.value ||
      this.currentParameters.hubId?.value
    )
      count++;
    return count;
  }

  get isApplyDisabled() {
    return (
      !this.tempParameters.caseType?.value &&
      !this.tempParameters.productType?.value &&
      !this.tempParameters.sttClientAggregatorType?.value &&
      !this.tempLastLocation.length
    );
  }

  toggleFilter() {
    this.isOpen = !this.isOpen;
    if (this.isOpen) {
      // Sync temp with current props when opening
      this.tempParameters.caseType = this.currentParameters.caseType;
      this.tempParameters.productType = this.currentParameters.productType;
      this.tempParameters.sttClientAggregatorType = this.currentParameters.sttClientAggregatorType;

      const currentCity = this.currentParameters.cityCode?.value
        ? this.currentParameters.cityCode.value.split(",")
        : [];
      const currentHub = this.currentParameters.hubId?.value
        ? this.currentParameters.hubId.value.split(",")
        : [];

      this.tempLastLocation = currentCity.map((city: string, idx: number) => ({
        cityCode: city,
        hubId: Number(currentHub[idx] ?? 0)
      }));
    }
  }

  closeFilter() {
    if (this.isOpen) {
      this.isOpen = false;
    }
  }

  selectTempFilter(data: OptionsClass, type: string) {
    (this.tempParameters as any)[type] = data;
  }

  resetFilter() {
    this.tempParameters.caseType = new OptionsClass();
    this.tempParameters.productType = new OptionsClass();
    this.tempParameters.sttClientAggregatorType = new OptionsClass();
    this.tempLastLocation = [];

    const lastLocationRef = this.$refs.lastLocationFilterRef as any;
    if (lastLocationRef?.reset) {
      lastLocationRef.reset();
    }

    this.applyFilter();
  }

  applyFilter() {
    const cityCodes = this.tempLastLocation.map((item) => item.cityCode);
    const hubIds = this.tempLastLocation.map((item) => item.hubId);

    this.$emit("apply", {
      caseType: this.tempParameters.caseType,
      productType: this.tempParameters.productType,
      sttClientAggregatorType: this.tempParameters.sttClientAggregatorType,
      cityCodes,
      hubIds
    });
    this.isOpen = false;
  }
}
